module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_five.5c2a011a.png";